export default "__VITE_ASSET__a56e95a5__"